import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { RatePackageEventType } from './../rate-package.event.type';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';
import { RatePackageService } from './../rate-package.service';
import { Pacote } from '../models/pacote.model';
import { Util } from '../../../utils/util';
import { User } from '../../../autentication/models/user';
import { Auth } from '../../../autentication/Auth';

@Component({
	selector: 'app-my-package',
	templateUrl: './my-package.component.html',
	styleUrls: ['./my-package.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class MyPackageComponent implements OnInit, OnDestroy {
	user: User;

	public active: Boolean = false;
	public currentPackage: Pacote = null;
	public servicePackageRows = [
		{
			code: '1.1.',
			desc: 'Confecção de cadastro para início de relacionamento',
			qty: '-',
			val: 'R$ 4.000,00'
		},
		{
			code: '2.3.1.',
			desc: 'Saque*',
			qty: '8 por mês',
			val: 'Isento'
		},
		{
			code: '2.5.1.',
			desc: 'Extrato Mensal*',
			qty: '4 por mês',
			val: 'R$ 12,00'
		},
		{
			code: '2.5.2.',
			desc: 'Extrato do período referente ao mês imediatamente anterior',
			qty: '2 por mês',
			val: 'R$ 12,00'
		},
		{
			code: '3.3.',
			desc: 'Transferência entre contas na própria instituição*',
			qty: '4 por mês',
			val: 'R$ 0,99'
		}
	];
	

	constructor(private ratePackageService: RatePackageService) { }

	ngOnInit() {
		AppEventDispatcher.listen(RatePackageEventType.STEPS.MY_PACKAGE, data => {
			if (data.show) {
				this.getPackage();
			} else {
				this.hide();
			}
		});

		this.user = Auth.getInstance().getUser();
	}

	ngOnDestroy = () => AppEventDispatcher.removeListener(RatePackageEventType.STEPS.MY_PACKAGE);

	getPackage() {
		this.preload(true);
		this.active = true;

		this.ratePackageService.getPackage().subscribe(data => {
			if (data.Sucesso && data.Retorno) {
				this.currentPackage = Util.keysToCamel(data.Retorno) as Pacote;
			}
			this.preload(false);
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Ocorreu um erro, tente novamente mais tarde.' });
			this.preload(false);
		});
	}

	hide = () => this.active = false;

	preload(active: boolean, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD, {
			element: '[data-component="rate-packege"] .content',
			show: active,
			delay: delay
		});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/rate-package/my-package/my-package.component.ts